window.unitToDays = window.unitToDays || {
    'week': 7,
    'month': 30,
    'year': 365
};

window.baseUrl = window.baseUrl || "https://dashboard.oddbunch.ca/";
const HISTORY_KEY_CANCEL = 'cancel_flow_history';

let currentSubscription = null;
let currentOffers = [];
let currentFlowId = null;
let tokenRefreshPromise = null;

function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

window.addEventListener('pagehide', () => {
    localStorage.removeItem(HISTORY_KEY_CANCEL);
    localStorage.removeItem('app_navigation_history');
});

async function loginUser(authPayload) {
    try {
        const response = await fetch(`${window.baseUrl}api/login.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(authPayload)
        });

        const data = await response.json();
        if (data.success) {
            sessionStorage.setItem('access_token', data.access_token);
            sessionStorage.setItem('refresh_token', data.refresh_token);
            sessionStorage.setItem('expires_at', data.expires_at);
            return true;
        }
        return false;
    } catch (error) {
        console.error("Login API call error:", error);
        return false;
    }
}

function isSameOriginAsApi(url) {
    try {
        const target = new URL(url, window.baseUrl);
        const base = new URL(window.baseUrl);
        return target.origin === base.origin;
    } catch (e) {
        return false;
    }
}

async function secureFetch(url, options = {}) {
    if (!isSameOriginAsApi(url)) {
        console.error("secureFetch blocked: refusing to send auth token to a different origin.", url);
        return null;
    }

    let accessToken = sessionStorage.getItem('access_token');
    let refreshToken = sessionStorage.getItem('refresh_token');
    let expiresAt = sessionStorage.getItem('expires_at');

    if (!accessToken) {
        console.error("No access token found. Request aborted.");
        return null;
    }

    const currentTime = new Date();
    let tokenExpiryTime;

    if (expiresAt && !expiresAt.includes('Z') && !expiresAt.includes('+')) {
        const formattedExpiry = expiresAt.replace(' ', 'T');
        const estOffsetString = new Date().toLocaleString("en-US", { timeZone: "America/New_York", timeZoneName: "short" });
        const isEDT = estOffsetString.includes("EDT");
        tokenExpiryTime = new Date(`${formattedExpiry}${isEDT ? '-04:00' : '-05:00'}`);
    } else {
        tokenExpiryTime = new Date(expiresAt);
    }

    if (currentTime.getTime() >= (tokenExpiryTime.getTime() - 60000)) {
        if (!tokenRefreshPromise) {
            tokenRefreshPromise = (async () => {
                try {
                    const apiBase = window.baseUrl || 'https://dashboard.oddbunch.ca/';
                    const refreshResponse = await fetch(`${apiBase}api/refreshToken.php`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ refresh_token: refreshToken })
                    });
                    const refreshData = await refreshResponse.json();
                    if (refreshData.success) {
                        sessionStorage.setItem('access_token', refreshData.access_token);
                        sessionStorage.setItem('refresh_token', refreshData.refresh_token);
                        sessionStorage.setItem('expires_at', refreshData.expires_at);
                        return refreshData.access_token;
                    } else {
                        console.error("Expired or invalid refresh token");
                        sessionStorage.clear();
                        return null;
                    }
                } catch (error) {
                    console.error("Token refresh error:", error);
                    return null;
                } finally {
                    tokenRefreshPromise = null;
                }
            })();
        }
        const renewedToken = await tokenRefreshPromise;
        if (!renewedToken) return null;
        accessToken = renewedToken;
    }

    options.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    };
    return fetch(url, options);
}

window.secureFetch = secureFetch;

function isSubscriptionSkipped(subscription) {
    if (!subscription) return false;
    const now = new Date();
    const estStr = now.toLocaleString("en-US", { timeZone: "America/New_York", hour12: false });
    const estNow = new Date(estStr);
    const estDayOfWeek = estNow.getDay();
    const estHour = estNow.getHours();
    const thisWednesday = new Date(estNow);
    thisWednesday.setDate(estNow.getDate() + (3 - estDayOfWeek));
    thisWednesday.setHours(0, 0, 0, 0);

    const frequency = subscription.order_interval_frequency || 1;
    const unit = subscription.order_interval_unit;
    let daysToAdd = 0;
    if (unit === 'week') daysToAdd = 7 * frequency;
    else if (unit === 'month') daysToAdd = 30 * frequency;
    else if (unit === 'year') daysToAdd = 365 * frequency;

    let expectedChargeDate = new Date(thisWednesday);
    const isPastCutoff = (estDayOfWeek > 3 || (estDayOfWeek === 3 && estHour >= 0));
    if (isPastCutoff) {
        expectedChargeDate.setDate(thisWednesday.getDate() + daysToAdd);
    }
    const [y, m, d] = subscription.next_charge_scheduled_at.split('-').map(Number);
    const actualNextCharge = new Date(y, m - 1, d);
    actualNextCharge.setHours(0, 0, 0, 0);
    return actualNextCharge.getTime() > expectedChargeDate.getTime();
}

function renderOffer(offer, index) {
    const container = document.getElementById('dynamic-offer-container');
    if (!container || !currentSubscription) return;

    const SkippedThrough = isSubscriptionSkipped(currentSubscription);
    if (SkippedThrough) {
        container.classList.add('hidden');
        return;
    } else {
        container.classList.remove('hidden');
    }

    let title = "Offre spéciale";
    let description = "Nous aimerions beaucoup que vous restiez parmi nous.";
    let btnText = "Postuler à l'offre";

    const meta = (offer && offer.offer_metadata) || {};

    if (offer.offer_type === 'discount') {
        title = "Bénéficiez d'une réduction";
        description = `Bénéficiez d'une réduction de ${escapeHtml(meta.discount_percent)} % sur votre prochaine commande !`;
        btnText = "Appliquer la réduction";
    } else if (offer.offer_type === 'skip' || meta.delay_option) {
        title = "Tu as besoin de plus de temps ?";
        description = meta.delay_option?.label
            ? escapeHtml(meta.delay_option.label)
            : "Annulez votre prochaine livraison tout en conservant votre abonnement.";
        btnText = "Ignorer la prochaine livraison";
    } else if (offer.offer_type === 'swap') {
        title = "Tu veux essayer autre chose ?";
        description = "Échangez l'article que vous avez actuellement contre un autre produit.";
        btnText = "Échanger un produit";
    } else if (offer.offer_type === 'no-op') {
        container.innerHTML = '';
        return;
    }

    const html = `
        <div class="offer-card" style="background: #ffeaef; border: 1px solid #b2d7ff; padding: 15px; border-radius: 10px; margin-bottom: 20px;">
            <h4 style="margin: 0 0 10px 0;text-align: center;">${escapeHtml(title)}</h4>
            <p style="font-size: 14px; margin-bottom: 15px;">${description}</p>
            <button onclick="processOfferClaim(event, ${Number(index)})" style="background: #397548; color: white; border: none; padding: 10px 20px; border-radius: 24px; cursor: pointer; width: 100%; font-weight: 700; font-family: Roboto; font-size: 16px;">
                ${escapeHtml(btnText)}
            </button>
        </div>
    `;
    container.insertAdjacentHTML('beforeend', html);
}

window.processOfferClaim = (event, index) => {
    const offer = currentOffers[index];
    if (!offer || !currentSubscription) return;
    const meta = offer.offer_metadata;

    let payload = {
        action: 'offers_claim',
        subscription_id: currentSubscription.id,
        claim_id: offer.claim_id
    };

    if (meta.delay_option) {
        payload.delay_option = {
            delay: meta.delay_option.delay,
            delay_unit: meta.delay_option.delay_unit
        };
        if (meta.delay_option.label) payload.delay_option.label = meta.delay_option.label;
        if (meta.delay_option.nextShipmentDate) payload.delay_option.nextShipmentDate = meta.delay_option.nextShipmentDate;
    }

    if (offer.external_variant_id || meta.swap_data) {
        payload.external_variant_id = offer.external_variant_id || meta.external_variant_id;
        payload.swap_data = meta.swap_data;
    }

    if (meta.change_frequency) {
        payload.change_frequency = meta.change_frequency;
    }

    if (offer.customer_id || currentSubscription.customer_id) {
        payload.customer_id = offer.customer_id || currentSubscription.customer_id;
    }

    const btn = event.target;
    btn.innerText = "Postuler...";
    btn.disabled = true;

    window.secureFetch(`${window.baseUrl}api/actions.php`, {
        method: 'POST',
        body: JSON.stringify(payload)
    })
    .then(r => r ? r.json() : { success: false })
    .then(data => {
        if (data.id || data.success) {
            alert("C'est fait ! Votre abonnement a été mis à jour.");
            document.location.href = `/fr/account`;
        } else {
            alert("Erreur lors de l'application de l'offre.");
            btn.innerText = "Postuler à l'offre";
            btn.disabled = false;
        }
    })
    .catch(err => {
        console.error(err);
        btn.innerText = "Postuler à l'offre";
        btn.disabled = false;
    });
};

window.submitFinalCancellation = () => {
    if (!currentSubscription) return;
    const selected = document.querySelector('input[name="radio-group"]:checked');
    let reason_accpt = selected ? selected.getAttribute('response') : "Aucune raison n'a été fournie";
    reason_accpt = reason_accpt.trim().replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
    const reason_comment = document.querySelector('#cancelReason__thought')?.value || '';
    const cancelBtn = document.getElementById('btn_final_cancel_action_final');

    if (cancelBtn) {
        if (cancelBtn.style.pointerEvents === "none") return;
        cancelBtn.innerText = "Traitement...";
        cancelBtn.style.pointerEvents = "none";
    }

    window.secureFetch(`${window.baseUrl}api/actions.php`, {
        method: 'POST',
        body: JSON.stringify({
            action: 'cancel',
            subscription_id: currentSubscription.id,
            reason: reason_accpt,
            reason_comment: reason_comment
        })
    })
    .then(r => r ? r.json() : { success: false })
    .then(d => {
        if (d.success) {
            document.location.href = `/fr/account`;
        } else {
            alert("Erreur: " + (d.message || "Impossible d'annuler"));
            if (cancelBtn) {
                cancelBtn.innerText = "Confirmer l'annulation";
                cancelBtn.style.pointerEvents = "auto";
            }
        }
    })
    .catch(err => {
        console.error(err);
        if (cancelBtn) {
            cancelBtn.innerText = "Confirmer l'annulation";
            cancelBtn.style.pointerEvents = "auto";
        }            
    });
};

window.fetchCancellationReasonOptions = function () {
    let itemsContainer = document.querySelector('.rsnSltItem');
    if (!itemsContainer || !currentSubscription) return;

    window.secureFetch(`${window.baseUrl}api/actions.php`, {
        method: 'POST',
        body: JSON.stringify({
            action: 'cancellation_reason_options',
            "subscription_id": currentSubscription.id,
            "customer_id": currentSubscription.customer_id
        })
    })
    .then(r => r ? r.json() : { success: false })
    .then(d => {
        if (d.success && d.response && d.response.responses) {
            currentFlowId = d.response.id;
            if (itemsContainer.querySelectorAll('.rsnSltcheck').length === 0) {
                d.response.responses.forEach((val, index) => {
                    const isChecked = index === 0 ? 'checked' : '';
                    const safeId = escapeHtml(val.id);
                    const safeResponse = escapeHtml(val.response);
                    let html = `
                    <div class="rsnSltcheck"> 
                        <input type="radio" 
                            id="reason_${safeId}" 
                            name="radio-group" 
                            value="${safeId}" response="${safeResponse}" 
                            ${isChecked}>
                        <label for="reason_${safeId}">
                            <span class="radioSelect"></span>${safeResponse}
                        </label>
                    </div>
                `;
                    itemsContainer.insertAdjacentHTML('beforeend', html);
                });
            }
        }
    })
    .catch(err => console.error("Error loading reasons:", err));
};

window.openFinalCancelConfirm = () => {
    const selected = document.querySelector('input[name="radio-group"]:checked');
    if (!selected) return alert("Veuillez d'abord sélectionner un motif.");
    if (!currentSubscription) return;

    const reasonId = selected.value;
    const reasonText = selected.nextElementSibling ? selected.nextElementSibling.innerText : "";

    const displayEl = document.getElementById('final_cancel_reason_display');
    if (displayEl) displayEl.innerText = reasonText;

    const thoughtInput = document.querySelector('#cancelReason__thought');
    if (thoughtInput) thoughtInput.value = reasonText;

    const offerContainer = document.getElementById('dynamic-offer-container');
    if (offerContainer) offerContainer.innerHTML = `<p style="text-align: center;padding: 10px 0px;">Recherche d'offres spéciales...</p>`;

    window.secureFetch(`${window.baseUrl}api/actions.php`, {
        method: 'POST',
        body: JSON.stringify({
            "action": "cancellation_offer",
            "flow_id": currentFlowId,
            "response_id": reasonId,
            "customer_id": currentSubscription.customer_id
        })
    })
    .then(r => r ? r.json() : { success: false })
    .then(data => {
        if (offerContainer) offerContainer.innerHTML = '';
        if (data.success && data.response && data.response.response_offer_lookup && data.response.response_offer_lookup.offers) {
            currentOffers = data.response.response_offer_lookup.offers;
            currentOffers.forEach((offer, index) => {
                renderOffer(offer, index);
            });
        }
    })
    .catch(err => {
        console.error("Error processing cancellation offer:", err);
        if (offerContainer) offerContainer.innerHTML = '';
    });
    window.openPagevwType('final-cancel-process-page');
};

window.getCachedSubscription = function () {
    let LocalStorageItem = localStorage.getItem('currentSubscription');
    if (!LocalStorageItem) return null;

    try {
        let LocalStorageJson = JSON.parse(LocalStorageItem);
        let CurrentTimeEscape = new Date();
        if (CurrentTimeEscape.getTime() > LocalStorageJson.expiry) {
            localStorage.removeItem('currentSubscription');
            return null;
        }
        return LocalStorageJson.value;
    } catch (e) {
        return null;
    }
};

window.openPagevwType = window.openPagevwType || function (mdty) {
    let ModalType = mdty;
    let historyList = JSON.parse(localStorage.getItem(HISTORY_KEY_CANCEL)) || [];
    if (ModalType !== 'cancel-process-five-page') {
        if (historyList[historyList.length - 1] !== ModalType) {
            historyList.push(ModalType);
            localStorage.setItem(HISTORY_KEY_CANCEL, JSON.stringify(historyList));
        }
    }
    document.querySelectorAll(`[data-page-open]`).forEach((ot) => { ot.classList.add('hidden') });
    const targetPage = document.querySelector(`[data-page-open="${ModalType}"]`);
    if (targetPage) targetPage.classList.remove('hidden');
    window.scrollTo({ top: 0, behavior: "smooth" });
};

document.addEventListener('DOMContentLoaded', async () => {
    let isAuthReady = false;
    let currentToken = sessionStorage.getItem('access_token');

    if (!currentToken) {
        if (typeof recharge !== 'undefined' && recharge.auth) {
            try {
                const session = await recharge.auth.loginShopifyAppProxy();

                const authPayload = {
                    token: session.token || session.apiToken || (typeof session === 'string' ? session : null),
                    customerId: session.customerId || (session.customer && session.customer.id) || null,
                    apiToken: session.apiToken || null
                };

                const finalPayload = authPayload.token ? authPayload : session;
                const loginSuccess = await loginUser(finalPayload);
                if (loginSuccess) isAuthReady = true;
            } catch (e) {
                console.error("Recharge dynamic authentication failure:", e);
            }
        }
    } else {
        isAuthReady = true;
    }

    if (!isAuthReady) {
        console.error("API Auth Not actioned or validated.");
    }

    let history = JSON.parse(localStorage.getItem(HISTORY_KEY_CANCEL)) || [];
    if (history.length === 0) {
        const activePage = document.querySelector('[data-page-open]:not(.hidden)');
        const initialState = activePage ? activePage.getAttribute('data-page-open') : 'home';
        history.push(initialState);
        localStorage.setItem(HISTORY_KEY_CANCEL, JSON.stringify(history));
    }

    currentSubscription = window.getCachedSubscription();
    if (!currentSubscription) {
        const rawSub = localStorage.getItem('currentSubscription');
        if (rawSub) {
            try { currentSubscription = JSON.parse(rawSub).value; } catch (e) { }
        }
    }

    if (currentSubscription) {
        const p = parseFloat(currentSubscription.price).toFixed(2);
        const orderIntervalFrequency = (currentSubscription.order_interval_frequency == 1) ? '' : currentSubscription.order_interval_frequency;
        const orderIntervalUnit = currentSubscription.order_interval_unit;

        let ImageHaveBuilt = window.defaultProductImage || '';
        if (window.AllproductImages) {
            const productImageHave = window.AllproductImages.find(item => item.product_id === currentSubscription.external_product_id.ecommerce);
            if (productImageHave) { ImageHaveBuilt = productImageHave.SmallImage; }
        }

        document.querySelectorAll(`[js-final-cancel-img]`).forEach((el) => { el.innerHTML = `<img src="${escapeHtml(ImageHaveBuilt)}">` });
        document.querySelectorAll(`[js-final-cancel-title]`).forEach((el) => { el.innerHTML = `${escapeHtml(currentSubscription.product_title)}` });
        document.querySelectorAll(`[js-final-cancel-price]`).forEach((el) => {
            el.innerHTML = `CA$${escapeHtml(p)} <span class="everyWeekBadge">Every ${escapeHtml(orderIntervalFrequency)} ${escapeHtml(orderIntervalUnit)}</span>`;
        });
    }

    window.fetchCancellationReasonOptions();
});